// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"ed8e9ef5","453":"a3c1d153"}[chunkId] + ".chunk.js";
};